import React,{useState,useEffect,useRef} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Button} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import moment from 'moment'
import {BsSearch} from 'react-icons/bs'
import { empwiseattApi } from '../../../utils/AdminDashApi/EmpWiseAttApi'
import '../../../sassFiles/sassPages/admindashboard/campwiseatten.scss'
import '../../../sassFiles/sassPages/admindashboard/adminCommon.scss'
import { empAttreportApi } from '../../../utils/AdminDashApi/EmpAttReportApi'
import { BsPlus } from 'react-icons/bs'
import { optionsCampus, optionsClass, optionsShift, optionsdayofmonth, optionsdayofweek, optionsdept, optionsdesignation, optionsexptype, purplebutton40 } from '../../Helper'
import { validationComp, validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'
import { studentSubjectApi } from '../../../utils/AdminDashApi/StudentSubjectApi'
const StudentSubjectComp = () => {
  const [activefrom,setactivefrom] = useState("")
  const [activeto,setactiveTo] = useState("")
  
  const [activefrommdlnm,setactivefrommdlnm] = useState("")
  const [activetomdl,setactiveTomdl] = useState("")
  const [activetomdlnm,setactiveTomdlnm] = useState("")
 

  const [department,setdepartment] = useState("")
  const [labeldepartment,setlabeldepartment] = useState("")
  const [borderdepartment,setborderdepartment] = useState("")
  const [campus,setcampus]= useState("")
  const [bordercampus,setbordercampus]= useState("")
  const [labelcampus,setlabelcampus]= useState("")
  const [type,settype]= useState("")
  const [bordertype,setbordertype]= useState("")
  const [labeltype,setlabeltype]= useState("")




  const [shifttypemain,setshifttypemain] = useState("")
  const [bordershifttypemain,setbordershifttypemain] = useState("")
  const [labelshifttypemain,setlabelshifttypemain] = useState("")



  const [enddatemain,setenddatemain] = useState("")
  const [borderenddatemain,setborderenddatemain] = useState("")
  const [labelenddatemain,setlabelenddatemain] = useState("")
  
  const [classmain,setclassmain] = useState("")
  const [borderclassmain,setborderclassmain] = useState("")
  const [labelclassmain,setlabelclassmain] = useState("")
  
  const [employeeIDmain,setemployeeIDmain] = useState("")
  const [borderemployeeIDmain,setborderemployeeIDmain] = useState("")
  const [labelemployeeIDmain,setlabelemployeeIDmain] = useState("")
  
  const [studentmain,setstudentmain] = useState("")
  const [borderstudentmain,setborderstudentmain] = useState("")
  const [labelstudentmain,setlabelstudentmain] = useState("")

  const drpfuncclassmain=(myval,myid)=>{
    setclassmain(myval)
  }
  const drpfuncstudentmain=(myval,myid)=>{
    setstudentmain(myval)
  }

 

const initialState = studentSubjectApi.data.map(item => ({
  ...item
}));
  const [ischkmodal, setischkmodal] = useState([initialState]);
  const [ischkmodalall, setischkmodalall] = useState([]);


  

  const updateTickmark = (myid, newValue) => {
    console.log(ischkmodal[0])

  
    // setischkmodal(prevData => ({
    //   ...prevData,
    //   [empid]: {
    //     ...prevData[empid],
    //     tickmark: newValue
    //   }
    // }));
    var myarr = ischkmodal[0]

    for(var i=0;i<myarr.length;i++){
      if(myid == myarr[i].id){
        
        myarr[i].tickmark = true
        setischkmodal(myarr)
      }

    }
    
    
   
  };
const handleChangechk = (event,myid) => {
    var checkedme = ""
    if (event.target.checked) {
      console.log('✅ Checkbox is checked');
      updateTickmark(myid, true);
    } else {
      console.log('⛔️ Checkbox is NOT checked');
      updateTickmark(myid, false);
    }
    
   
  };







const handleChangechkall = (event,myid) => {
    if (event.target.checked) {
      console.log('✅ Checkbox is checked');
    } else {
      console.log('⛔️ Checkbox is NOT checked');
    }
    setischkmodalall(current => !current);
  };


const handleSearch=()=>{
    console.log("searched")
}


  const handleShowEdit=(e,item)=>{
    setShow3(true)

    
  }

  const bottomSave=()=>{

    
    const finalarr = {
        tickmart: ischkmodal.length>1?ischkmodal:ischkmodal[0],
  }
    console.log(finalarr)
  }

 
 
  const [roleDrp,setRoledrp] = useState("")
 
 
  const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }
  const [statusvalueerr,setstatusvalueerr] = useState("")
  const [activefromMoment,setactivefromMoment] = useState("")


  
  
      const handleActiveTo = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveTomdl(dtfinalc)

            
        }
        
        
    }
   
 

    const [show3, setShow3] = useState(false);
    
  const [currentItems, setCurrentItems] = useState([]);
  const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(studentSubjectApi.data)



  const mainfilter=(arr)=>{
      setfilteredArr(arr);    
  }

  const drpfunctiondepartment=(myval,myid)=>{
    setdepartment(myval)
  }
  const drpfunctioncampus=(myval,myid)=>{
    setcampus(myval)
  }
  const drpfunctiontype=(myval,myid)=>{
    settype(myval)
  }



  const [tempfilteredarr,settempfilteredarr] = useState([])

  let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
  

  useEffect(() => {
    const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
    const tempArr = filteredArr.slice(itemOffsetfiltered, endOffsetfiltered);
    settempfilteredarr(tempArr);
    setPageCountfiltered(Math.ceil(filteredArr.length / itemsPerPagefiltered));
    
    //flag2
  }, [itemOffsetfiltered, itemsPerPagefiltered, filteredArr]);

      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % studentSubjectApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
    
      
    
   
    const [formdata,setfromdata]=useState({
      usersearch:""
    })
    

    // populatedata
    const [name,setname] = useState("")
    const [id,setid] = useState("")

    
   

   
    
    
    const optionsparentmenu = [
      {
        id:1,
        opt:"Home1"
      },
      {
        id:2,
        opt:"Home2"
      },
    ]
    const [parentmenudrp,setparentmenudrp] = useState("")
    const drpfuncparentmenu=(parentmenydrpval,myid)=>{
      setparentmenudrp(parentmenydrpval)
    }
    
  

  
   
  
  const handleInput = (e)=>{
    setfromdata({...formdata,[e.target.name]:e.target.value})
  }


 

  //start
    
  return (
    <div className="d-flex flexvaluecomp htshiftsetup">

       <SidebarOfAdash/>
       <div className="contentpartwidthwrapper">
          <HeaderofAdash head="Student Subject"/>
          <div className="contentofadmindash contentflexvalue">
           
                <Row >
                <Col lg={10} className="m-auto">
                    <Row>
                        
                        <Col lg={3}></Col>
                        <Col lg={3} className="pr7 pl7">
                        <div className="basicinputfield h40p ">

                            <p>Class</p>
                            <div className="inputgap h40">
                                <div className="dropdownwrapper">
                                    <Dropdown2 err={borderclassmain} func={drpfuncclassmain} myplaceholder={classmain}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsClass} />
                                </div>
                                <label>{labelclassmain}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={3} className="pr7 pl7">
                        <div className="basicinputfield h40p ">

                            <p>Student</p>
                            <div className="inputgap h40">
                                <div className="dropdownwrapper">
                                    <Dropdown2 err={borderstudentmain} func={drpfuncstudentmain} myplaceholder={studentmain}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsClass} />
                                </div>
                                <label>{labelstudentmain}</label>
                                </div>
                            </div>
                        </Col>
                        
                        <Col lg={3} className='pl7'>
                          
                                
                            <div className="purplebutton" style={{marginTop:"18px"}}>
                                <button onClick={handleSearch} style={purplebutton40}><BsSearch/></button>
                            </div>
                            
                        </Col>
                    </Row>
                </Col> 

                </Row>
               
               

              <Row>
                <Col lg={10} className="m-auto">
                  <div className="flexvaluetable studentsubject">
                    <table>
                      <thead>
                        <tr>
                       
                               
                                
                            {
                              studentSubjectApi.heading.map((item,key)=>{
                                    
                                return(
                                    <>
                                  <th colSpan={2} key={key}> <div>{item.head}</div> </th>
                                    
                                    </>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            tempfilteredarr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                    
                                  <td>
                                  <input
                                      type="checkbox"
                                      value={ischkmodal}
                                      onChange={(e)=>handleChangechk(e,item.id)}
                                      id="modalchk"
                                      name="modalchk"                        
                                  />
                                  </td>
                                  <td>{item.subjectname}</td>
                                
                                </tr>
                              )
                            })
                            :
                            ""
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={10} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={5}
                      pageCount={pageCountfiltered}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffset+1} to {itemOffset+10} of {studentSubjectApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                    }
                  <Row>
                    <Col lg={12} className="d-flex justify-content-center">
                      <div className="purplebutton d-inline">

                        <button className='px-4 py-2' onClick={bottomSave}>
                            Save
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Col>
               
              </Row>
              

              
              </div>
              </div>
              </div>
  )
 }

export default StudentSubjectComp